import gql from 'graphql-tag';

/**
 * "Pay with hotel room", served by galaxy's hotel service. Errors come back as
 * `ERROR_HOTEL_<CODE>: <detail>`: in `error` on mutations, thrown on queries.
 * See `services/hotel/src/functions/hotel-charge-cheque-to-room/README.md`.
 */

export const HOTEL_SEARCH_GUESTS = gql`
  query HotelSearchGuests($venueId: ID!, $lastName: String, $roomNumber: String) {
    hotelSearchGuests(venueId: $venueId, lastName: $lastName, roomNumber: $roomNumber) {
      id
      guestId
      roomNumber
      lastName
      firstName
      noPost
    }
  }
`;

export const HOTEL_SEARCH_PM_ACCOUNTS = gql`
  query HotelSearchPmAccounts($venueId: ID!, $query: String!) {
    hotelSearchPmAccounts(venueId: $venueId, query: $query) {
      id
      number
      name
      noPost
    }
  }
`;

export const HOTEL_CHARGE_CHEQUE_TO_ROOM = gql`
  mutation HotelChargeChequeToRoom($input: HotelChargeChequeToRoomInput!) {
    hotelChargeChequeToRoom(input: $input) {
      success
      error
      postings {
        reference
        amount
      }
    }
  }
`;

/** Settles a charge that failed with UNCONFIRMED, once reception has checked the folio. */
export const HOTEL_RESOLVE_ROOM_CHARGE = gql`
  mutation HotelResolveRoomCharge($input: HotelResolveRoomChargeInput!) {
    hotelResolveRoomCharge(input: $input) {
      success
      error
      postings {
        reference
        amount
      }
    }
  }
`;

export const HOTEL_CORRECT_ROOM_CHARGE = gql`
  mutation HotelCorrectRoomCharge($input: HotelCorrectRoomChargeInput!) {
    hotelCorrectRoomCharge(input: $input) {
      success
      error
      postings {
        reference
        amount
      }
    }
  }
`;
